<template>
  <div>
    <div v-if="errorCount&&!isSaving&&$mq!='xs'" class="errorCount " @click="gotoFirstError">
      <fa size="2x" icon="exclamation-circle" />
      <div class="p-2">{{errorCount}}</div>
    </div>
    <row>
      <column>
        <btn v-if="showPrevPageBtn" class="btn-sm" block btn-class="primary" @click.native="gotoPrevPage" :disabled="currentPage==1">Prev Page</btn>
        <span v-if="lastSaved"> Last saved: {{lastSaved}} </span>
      </column>
      <column>
        <btn v-if="!saveHidden&&!showSaveAndNext&&!showSaveAndHome" class="btn-sm" block :btn-class="validClass" @click.native="saveRecords" :disabled="isSaving">
          <fa v-if="isSaving" icon="cog" spin />
          <span> Save </span>
          <span v-if="changed"> Changes </span>
        </btn>
      </column>
      <column>
        <btn v-if="showNextPageBtn&&!lastPage" class="btn-sm" btn-class="primary" block @click.native="gotoNextPage" :disabled="!canProgressToNextPage">Next Page</btn>
        <btn v-if="showSaveAndHome" class="btn-sm" block btn-class="primary" tabindex="0" @click.native="saveRecords('goHome')" :disabled="errorCount>0||isSaving">
          Save &amp; Next
        </btn>
        <btn v-else-if="showSaveAndNext||(pages&&currentPage==pages.length)" class="btn-sm" block btn-class="primary" tabindex="0" @click.native="saveRecords('gotoNextQuestionnaire')" :disabled="errorCount>0||isSaving">
          Save &amp; Next
        </btn>
        
      </column>
    </row>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import pages from '~/mixins/pages'
export default {
  name: 'questionnaire-footer',
  mixins: [pages],
  props: {
    saveHidden: {},
    showNextPageBtn: Boolean,
    showPrevPageBtn: Boolean,
    showSaveAndNext: Boolean,
    showSaveAndHome: Boolean,
    pages: {},
  },
  computed: {
    ...mapState(['records', 'questionnaire', 'isSaving', 'changed', 'errors']),
    errorCount() {
      var errorCount = 0;
      for (var key in this.errors) {
        var di = this.errors[key];
        if (Array.isArray(di)) {
          var coll = di;
          for (var i = 0; i < coll.length; i++) {
            if (typeof coll[i] === "object")
              for (var key in coll[i]) {
                var di = coll[i][key]
                errorCount += di.length
              }
            else {
              errorCount += coll.length
            }
          };
        } else {
          errorCount += di.length
        }
      }
      return errorCount
    },
    validClass() {
      var invalid = false;
      if (this.errors) {
        for (var error in this.errors) {
          if (this.errors[error] != null) invalid = true;
          if ($.isEmptyObject(this.errors[error])) invalid = false;
        }
      }
      return invalid ? 'danger' : 'success'
    },
    lastSaved() {
      if (this.records)
        if (this.records.updated_at) {
          var now = moment();
          var lastSaved = moment(this.records.updated_at);
          return lastSaved.from(now);
        }
      return null;
    },
  },
  methods: {
    ...mapActions(['update']),
    gotoNextQuestionnaire() {
      eventBus.$emit('gotoNextQuestionnaire')
    },
    gotoFirstError() {
      eventBus.$emit('gotoFirstError')
    },
    saveRecords(callback) {
      if (this.isSaving) return false
      this.update({ isSaving: true });
      eventBus.$emit('saveRecords', callback)
    },
  }
}

</script>
